import PropTypes from 'prop-types';
import './StyleControls.css';

const FONTS = [
  'Arial',
  'Times New Roman',
  'Helvetica',
  'Georgia',
  'Verdana',
  'Courier New',
  'Trebuchet MS',
  'Impact'
];

const StyleControls = ({ selectedBox, onUpdate, onDelete }) => {
  if (!selectedBox) return null;

  const updateStyle = (property, value) => {
    onUpdate(selectedBox.id, {
      styles: {
        ...selectedBox.styles,
        [property]: value
      }
    });
  };

  return (
    <div className="style-controls">
      <div className="control-section">
        <h3>Text</h3>
        <div className="control-group">
          <label>Font Family:</label>
          <select
            value={selectedBox.styles.fontFamily || 'Arial'}
            onChange={(e) => updateStyle('fontFamily', e.target.value)}
          >
            {FONTS.map(font => (
              <option key={font} value={font} style={{ fontFamily: font }}>
                {font}
              </option>
            ))}
          </select>
        </div>

        <div className="control-group">
          <label>Font Size:</label>
          <input
            type="number"
            value={parseInt(selectedBox.styles.fontSize) || 16}
            onChange={(e) => updateStyle('fontSize', `${e.target.value}px`)}
          />
        </div>

        <div className="control-group">
          <label>Font Weight:</label>
          <select
            value={selectedBox.styles.fontWeight || 'normal'}
            onChange={(e) => updateStyle('fontWeight', e.target.value)}
          >
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
            <option value="lighter">Light</option>
          </select>
        </div>

        <div className="control-group">
          <label>Text Align:</label>
          <div className="button-group">
            {['left', 'center', 'right', 'justify'].map(align => (
              <button
                key={align}
                className={`align-button ${selectedBox.styles.textAlign === align ? 'active' : ''}`}
                onClick={() => updateStyle('textAlign', align)}
              >
                <i className={`fas fa-align-${align}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="control-group">
          <label>Text Color:</label>
          <input
            type="color"
            value={selectedBox.styles.color || '#000000'}
            onChange={(e) => updateStyle('color', e.target.value)}
          />
        </div>
      </div>

      <div className="control-section">
        <h3>Box</h3>
        <div className="control-group">
          <label>Background:</label>
          <input
            type="color"
            value={selectedBox.styles.backgroundColor || '#ffffff'}
            onChange={(e) => updateStyle('backgroundColor', e.target.value)}
          />
        </div>

        <div className="control-group">
          <label>Border Width:</label>
          <input
            type="number"
            value={parseInt(selectedBox.styles.borderWidth) || 1}
            onChange={(e) => updateStyle('borderWidth', `${e.target.value}px`)}
          />
        </div>

        <div className="control-group">
          <label>Border Style:</label>
          <select
            value={selectedBox.styles.borderStyle || 'solid'}
            onChange={(e) => updateStyle('borderStyle', e.target.value)}
          >
            <option value="solid">Solid</option>
            <option value="dashed">Dashed</option>
            <option value="dotted">Dotted</option>
          </select>
        </div>

        <div className="control-group">
          <label>Border Color:</label>
          <input
            type="color"
            value={selectedBox.styles.borderColor || '#dddddd'}
            onChange={(e) => updateStyle('borderColor', e.target.value)}
          />
        </div>

        <div className="control-group">
          <label>Border Radius:</label>
          <input
            type="number"
            value={parseInt(selectedBox.styles.borderRadius) || 0}
            onChange={(e) => updateStyle('borderRadius', `${e.target.value}px`)}
          />
        </div>
      </div>

      <div className="control-section">
        <h3>Actions</h3>
        <div className="control-group">
          <button 
            className="delete-button"
            onClick={() => onDelete(selectedBox.id)}
          >
            Delete Box
          </button>
        </div>
      </div>
    </div>
  );
};

StyleControls.propTypes = {
  selectedBox: PropTypes.shape({
    id: PropTypes.number.isRequired,
    styles: PropTypes.object.isRequired
  }),
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default StyleControls; 